import React from 'react';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Group} from '@pb/kit-component-group';

import type {ImportOptions} from 'src/openapi/admin/models/ImportOptions';

const getConfirmMessage = (replacedData: Array<string>, buttonName: string) =>

    `After clicking the “${buttonName}” button all the ${replacedData.join(', ')} of the migrated user will be replaced with the content from the selected “template” user. Do you want to continue?`;


const LABELS = {
    emailAlerts: 'Email alerts',
    templates: 'Layouts',
    savedSearches: 'Saved Searches/Lists',
};

export const ReplaceSearchesSettings = (props: {
    selectedTemplateUserId?: number | null,
    setSavedSearches: (value: boolean) => void,
    templates: boolean,
    setTemplates: (value: boolean) => void,
    emailAlerts: boolean,
    savedSearches: boolean,
    setEmailAlerts: (value: boolean) => void,
    onFieldChange?: (fieldName: string) => void,
}) => {

    const {
        selectedTemplateUserId,
        setSavedSearches,
        setTemplates,
        emailAlerts,
        setEmailAlerts,
        templates,
        savedSearches,
        onFieldChange,
    } = props;

    const checkboxDisabled = selectedTemplateUserId === null;

    return (
        <Group>
            <CheckBox
                disabled={checkboxDisabled}
                label={LABELS.savedSearches}
                checked={savedSearches}
                onCheckBoxChange={e => {
                    setSavedSearches(e.event.currentTarget.checked);
                    onFieldChange?.(LABELS.savedSearches);
                }}
                name="saved-searches"
            />
            <CheckBox
                disabled={checkboxDisabled}
                label={LABELS.emailAlerts}
                checked={emailAlerts}
                onCheckBoxChange={e => {
                    onFieldChange?.(LABELS.emailAlerts);
                    setEmailAlerts(e.event.currentTarget.checked);
                }}
                name="email-alerts"
            />
            <CheckBox
                disabled={checkboxDisabled}
                label={LABELS.templates}
                checked={templates}
                onCheckBoxChange={e => {
                    onFieldChange?.(LABELS.templates);
                    setTemplates(e.event.currentTarget.checked);
                }}
                name="templates"
            />
        </Group>
    );
};

export const ReplaceConfirmMessage = ({disabled, templates, emailAlerts, savedSearches, buttonName}: {
    disabled: boolean,
    templates: boolean,
    emailAlerts: boolean,
    savedSearches: boolean,
    buttonName: string,
}) => {
    if (disabled) {
        return null;
    }

    return (
        <span className="negative">
            {getConfirmMessage([
                savedSearches && LABELS.savedSearches,
                emailAlerts && LABELS.emailAlerts,
                templates && LABELS.templates].filter(e => e) as Array<string>, buttonName,
            )}
        </span>
    );
};

export const isDisabled = ({templateUserId, replaceSearches, replaceAlerts, replaceLayouts}: ImportOptions) => {
    if (!templateUserId) {
        return true;
    }
    return !replaceLayouts && !replaceAlerts && !replaceSearches;
};

